import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { logService } from "../../Services/logs.service";
import { globalServices } from "../../Services/global.service";
import { useTranslation } from "react-i18next";
import SpinnerLoading from "../Common/SpinnerLoading";
import Tooltip from "../Common/Tooltip";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import DatePicker, { registerLocale } from "react-datepicker";
import * as dateHelper from "../../Helpers/DateHelper";
import iconcontentcalendar from "../../Images/Icons/iconcontentcalendar.png";
import { useForm, Controller } from "react-hook-form";
import { Modal } from "react-bootstrap";
import JSONPretty from "react-json-pretty";
import moment from "moment";
const Index = () => {
  const {
    updateLocName,
    updateLocTenant,
    updateLocStore,
    updateLocPos,
    updateLocTab,
    updateLocKey,
    isMobile,
    selectedLanguageId,
  } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { control, errors, handleSubmit } = useForm();
  const { master } = roles;
  const { t: translator } = useTranslation();
  const [logs, setLogs] = useState([]);
  const [pType, setPType] = useState([]);
  const [update, setUpdate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);
  const [showData, setShowData] = useState(false);
  const [data, setData] = useState("");

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const [search, setSearch] = useState({
    provisionTypeId: 0,
    level: "",
    dateFrom: new Date(),
    dateTo: new Date(),
    sortName: "Name",
    isAsc: true,
  });

  const history = useHistory();

  useEffect(() => {
    if (![master].includes(Number(roleId))) history.push("/error-page/401");
    globalServices.getProvisionTypes().then((res) => {
      setPType(res.data);
    });
    setIsLoading(false);
    updateLocName("log");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
    updateLocKey(0);
  }, [update, search]);

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };
  // TODO Add modal to show data
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.cellIndex) {
        //history.push(`/tenants/${row.tenantId}`);
        setShowData(true);
        setData(row.data);
      }
    },
  };

  const getLogs = () => {
    setIsLoading(true);
    var m = moment();
    var date = moment(search.dateTo);
    m.set(date.toObject());

    logService
      .get({
        provisionTypeId: search.provisionTypeId,
        level: search.level,
        dateFrom: search.dateFrom,
        dateTo: date.endOf("day"),
        sortName: search.sortName,
        isAsc: search.isAsc,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setLogs(res.data.data);
        setPagination({ ...pagination, totalCount: res.data.totalCount });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="logId"
        data={data}
        columns={columns}
        rowClasses="boostrap-table-row"
        noDataIndication={translator("No-Data")}
        rowEvents={rowEvents}
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );
  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }
  function dataFormatter(cell) {
    return <span>...</span>;
  }
  const columns = [
    {
      dataField: "timestamp",
      text: "Vrijeme",
      formatter: dateTimeFormatter,
    },
    {
      dataField: "level",
      text: translator("Tentats-TableHeader-Name"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "actionTypeName",
      text: translator("Akcija"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "message",
      text: translator("Poruka"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "data",
      text: translator("Podaci"),
      hidden: Boolean(isMobile),
      formatter: dataFormatter,
      style: (colum, colIndex) => {
        return {
          width: "60px",
        };
      },
    },
  ];
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSearch({ ...search, [name]: value });
  };
  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Logovi")}</span>{" "}
          {!isLoading ? (
            <span className="badge badge-pill badge-primary">
              {" "}
              {pagination.totalCount}
            </span>
          ) : null}
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Filteri")}
            </legend>
            <form className="row" onSubmit={handleSubmit(getLogs)}>
              <div className="form-group col-lg-3 col-md-4 col-xs-12">
                <label>{translator("Akcija")}</label>{" "}
                <Tooltip text={translator("TenantTooltip-Msg")} />
                <select
                  className="form-control"
                  value={search.provisionTypeId}
                  onChange={(event) => {
                    setSearch({
                      ...search,
                      provisionTypeId: event.target.value,
                    });
                  }}
                >
                  <option value={0}>Sve</option>
                  {pType &&
                    pType.map((item, key) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                </select>
              </div>
              <div className="form-group col-lg-3 col-md-4 col-xs-12">
                <label>{translator("Razina")}</label>{" "}
                <Tooltip text={translator("TenantTooltip-Msg")} />
                <select
                  className="form-control"
                  value={search.level}
                  onChange={(event) => {
                    setSearch({
                      ...search,
                      level: event.target.value,
                    });
                  }}
                >
                  <option value="ERROR">Error</option>
                  <option value="INFO">Info</option>
                  <option value="WARN">Warn</option>
                  <option value="FATAL">Fatal</option>
                </select>
              </div>
              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <label>{translator("InvIssReport-ValidFrom")}</label>
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    maxDate={
                      search && search.dateFrom && new Date(search.dateFrom)
                    }
                    as={DatePicker}
                    control={control}
                    autoComplete="off"
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    name="dateFrom"
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    rules={{ required: true }}
                    valueName="selected"
                    onChange={function ([selected]) {
                      handleInputChange({
                        target: {
                          name: "dateFrom",
                          value: dateHelper.datePickerDateToUtc(selected),
                        },
                      });

                      return selected;
                    }}
                  />
                </div>
                {errors.validFrom && errors.validFrom.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <label>{translator("InvIssReport-ValidTo")}</label>
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    disabled={search && search.dateFrom ? false : true}
                    as={DatePicker}
                    minDate={
                      search && search.dateFrom && new Date(search.dateFrom)
                    }
                    control={control}
                    autoComplete="off"
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    name="dateTo"
                    rules={{ required: true }}
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    valueName="selected"
                    onChange={function ([selected]) {
                      handleInputChange({
                        target: {
                          name: "dateTo",
                          value: dateHelper.datePickerDateToUtc(selected),
                        },
                      });

                      return selected;
                    }}
                  />
                </div>
                {errors.validTo && errors.validTo.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <div className="form-group">
                  <button
                    className="btn btn-primary pull-left mt-2"
                    /* onClick={handleToSearch} */
                    type="submit"
                  >
                    <span className="icon icon-search"></span>{" "}
                    {translator("InvIssReport-Btn-Search")}
                  </button>
                </div>
              </div>
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={logs}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}

          <Modal
            size={"lg"}
            scrollable={true}
            show={showData}
            backdrop="static"
            dialogClassName="logs-modal"
            keyboard={false}
            centered
          >
            <Modal.Header>
              <Modal.Title>Detalji</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <JSONPretty
                style={{ fontSize: "1.1em" }}
                data={data}
                mainStyle="padding:1em"
                valueStyle="font-size:1em"
              ></JSONPretty>
            </Modal.Body>
            <Modal.Footer>
              <button
                onClick={() => setShowData(false)}
                type="button"
                className="btn btn-primary"
              >
                {translator("General-Close")}
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Index;
